import { useEffect, useId, useRef, useState } from 'react'
import { Mtds } from 'prove-common'

type EditableQuantityFieldProps = {
  value: number
  canEdit: boolean
  isSaving?: boolean
  onSave: (quantity: number) => void | Promise<void>
}

export const EditableQuantityField = ({
  value,
  canEdit,
  isSaving = false,
  onSave
}: EditableQuantityFieldProps) => {
  const popoverId = useId()
  const closeButtonRef = useRef<HTMLButtonElement>(null)
  const [draft, setDraft] = useState(String(value))
  const parsed = Number(draft)
  const isValid = draft.trim() !== '' && Number.isFinite(parsed)

  useEffect(() => {
    setDraft(String(value))
  }, [value])

  const reset = () => setDraft(String(value))

  const save = async () => {
    if (!isValid) return
    await onSave(parsed)
    setDraft(String(parsed))
    closeButtonRef.current?.click()
  }

  if (!canEdit) return <>{value}</>

  return (
    <>
      <Mtds.Button
        type='button'
        data-variant='tertiary'
        popoverTarget={popoverId}
        disabled={isSaving}
        className='-mx-1 h-auto min-h-0 min-w-0 justify-start font-normal [--mtdsc-button-padding:var(--mtds-1)]'
      >
        {value}
      </Mtds.Button>
      <Mtds.Popover id={popoverId} className='w-72 p-3'>
        <div className='grid gap-3'>
          <Mtds.Heading as='p' data-size='2xs'>
            Antall prøver
          </Mtds.Heading>
          <Mtds.Field
            as='input'
            type='number'
            aria-label='Antall prøver'
            value={draft}
            disabled={isSaving}
            onChange={({ target }) => setDraft(target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') void save()
              if (event.key === 'Escape') reset()
            }}
          />
          <Mtds.Flex data-gap='2'>
            <Mtds.Button
              ref={closeButtonRef}
              type='button'
              popoverTarget={popoverId}
              popoverTargetAction='hide'
              hidden
            />
            <Mtds.Button
              type='button'
              popoverTarget={popoverId}
              popoverTargetAction='hide'
              disabled={isSaving}
              onClick={reset}
            >
              Avbryt
            </Mtds.Button>
            <Mtds.Button
              type='button'
              data-variant='primary'
              disabled={!isValid || isSaving}
              onClick={() => void save()}
            >
              Lagre
            </Mtds.Button>
          </Mtds.Flex>
        </div>
      </Mtds.Popover>
    </>
  )
}
